import {
  UPDATE_PLC_SAFETY_EVENT,
  UPDATE_PLC_SAFETY_EVENT_SUCCESSFUL,
  UPDATE_PLC_SAFETY_EVENT_FAILED,
} from './actionTypes';

const initialState = {
  updatePlcSafetyEventError: null,
  messagePlcSafetyEvent: null,
  loadingUpdatePlcSafetyEvent: false,
};

const updateEvent = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PLC_SAFETY_EVENT:
      state = { ...state, loadingUpdatePlcSafetyEvent: true, updatePlcSafetyEventError: null };
      break;
    case UPDATE_PLC_SAFETY_EVENT_SUCCESSFUL:
      state = {
        ...state,
        loadingUpdatePlcSafetyEvent: false,
        messagePlcSafetyEvent: action.payload,
        updatePlcSafetyEventError: null,
      };
      break;
    case UPDATE_PLC_SAFETY_EVENT_FAILED:
      state = {
        ...state,
        messagePlcSafetyEvent: null,
        loadingUpdatePlcSafetyEvent: false,
        updatePlcSafetyEventError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateEvent;
